var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autocomplete',{ref:"autocomplete",attrs:{"search":_vm.search,"placeholder":"Buscar experiencia","aria-label":"Buscar experiencia","get-result-value":_vm.getResultValue},on:{"submit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }